import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { DataPlanType, UnlPlanSubgroup } from 'my-account/constants';
import { Subscription } from 'rxjs';
import { CimaCore } from 'services/cima/core';
import { Cloudinary } from 'services/cloudinary';
import { Formatter } from 'services/format';
import { XmStore, XmStoreUtil } from 'services/store';
import { AccountSummary, LineSummary } from 'store/account-summary/models';
import { CmsDataDetail } from 'store/cms/models';

@Component({
    selector: 'xm-tablet-segment-five',
    styleUrls: ['./tablet-segment-five.scss'],
    templateUrl: './tablet-segment-five.html',
    standalone: false
})
export class TabletSegmentFiveComponent implements OnInit{
    @Input() public planData: CmsDataPlanDetails;
    @Input() public currentLine: LineSummary;
 
    public inUseIcon: MediaImageOptions;
    public tabletIcon: MediaImageOptions;
    public inUse: string;
    public featureTitle: string;
    public dataFeatures: CmsDetailPlanFeature[];
    public isBusinessUser: boolean;
    public accountSummary: AccountSummary;
    public lineSummary: LineSummary;
    public pageData: CmsDataDetail;
    public cmsDataDetailPageData: CmsDataDetail;
    public cmsSeg5TabletData: CmsSegmentFiveTablet;
    public planEligibilityPromise: Promise<void>;

    private state: StateService;
    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private cimaCore: CimaCore;

    constructor(xmStore: XmStore, state: StateService, cimaCore: CimaCore) {
        Object.assign(this, { xmStore, state, cimaCore });
    }

    public ngOnInit(): void {
        this.isBusinessUser = this.cimaCore.isBusinessUser;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
            this.cmsDataDetailPageData = pageData;
            this.pageData = pageData;
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AccountSummary>(AccountSummary), (accountSummary: AccountSummary) => {
            this.accountSummary = accountSummary;
            this.lineSummary = this.accountSummary.getLineByKey(this.state.params.line_id);
            if (this.isBusinessUser){
                this.cmsSeg5TabletData = this.lineSummary.isUnlPremium ? this.pageData.segmentFiveCBMTabletUnlPremium : this.pageData.segmentFiveCBMTabletUnlIntro;   
            } else {
                this.cmsSeg5TabletData = this.pageData.segmentFiveTablet;
            }
            this.buildSegmentFiveTabletIcons();
            this.dataFeatures = this.getDataFeatures();
        }));
    }

    public generateFeatureIcon(image: CmsMediaImage): MediaImageOptions {
        return {
            mobile: Cloudinary.generateMediaFromCms(image)
        };
    }

    public getCurrentPlan(currentplan: string): string {

        return currentplan.replace('[CURRENT_PLAN]', this.getTabletCurrentPlan());
    }

    private buildSegmentFiveTabletIcons(): void {
        this.tabletIcon = {
            mobile: Cloudinary.generateMediaFromCms(this.cmsSeg5TabletData.icon)
        };

        this.inUseIcon = {
            mobile: Cloudinary.generateMediaFromCms(this.pageData.inUseIcon)
        };
    }

    private getDataFeatures(): CmsDetailPlanFeature[] {
        if (this.isBusinessUser && this.lineSummary.isScheduledSwitch && this.planData.planType === DataPlanType.UNLIMITED) {
            this.featureTitle = this.pageData.featureTitle;
            const features: CmsDetailPlanFeature[] = this.planData.scheduledSwitchCBMdataFeatures;

            return features && features.map((feature: CmsDetailPlanFeature) => ({
                ...feature,
                header: feature.header.replace('[SCHEDULED_SWITCH_PLAN]', this.getTabletScheduledSwitchPlan())
                    .replace('[Date]', Formatter.formatMonthDate(this.lineSummary.scheduledSwitch?.scheduleDate)),
                subheader: feature.subheader.replace('[SCHEDULED_SWITCH_PLAN]', this.getTabletScheduledSwitchPlan())
                    .replace('[CURRENT_PLAN]', this.getTabletCurrentPlan())
                    .replace('[Date]', Formatter.formatMonthDate(this.lineSummary.scheduledSwitch?.scheduleDate))
            }));
        } if (this.isBusinessUser && !this.lineSummary.isScheduledSwitch && this.planData.planType === DataPlanType.UNLIMITED) {
            if (this.lineSummary.isUnlBasic) {
                this.featureTitle = this.cmsDataDetailPageData.tabletUnlimitedPremium ;          
            } else if (this.lineSummary.isUnlPremium) {
                this.featureTitle = this.cmsDataDetailPageData.tabletUnlimitedIntro;
            }
            const features: CmsDetailPlanFeature[] = this.planData.featuresForLevel5CbmTablet;

            return features;
        }
    }

    private getTabletScheduledSwitchPlan(): string {
        switch (this.lineSummary.scheduledSwitch?.planSubgroup) {
            case UnlPlanSubgroup.BASIC:
                return this.pageData.tabletUnlimitedIntro;
            case UnlPlanSubgroup.PREMIUM:
                return this.pageData.tabletUnlimitedPremium;
        }
    }

    private getTabletCurrentPlan(): string {
        switch (this.lineSummary.planSubgroup) {
            case UnlPlanSubgroup.BASIC:
                return this.pageData.tabletUnlimitedIntro;
            case UnlPlanSubgroup.PREMIUM:
                return this.pageData.tabletUnlimitedPremium;
        }
    }

}
